const TOKENS = [
  ["sellerToken", "seller"],
  ["groupAdminToken", "group-admin"],
  ["adminToken", "admin"],
];

const resolveViewer = () => {
  for (const [key, role] of TOKENS) {
    const token = localStorage.getItem(key);
    if (token) return { token, role };
  }

  return { token: null, role: null };
};

export function snippetApiToken() {
  return resolveViewer().token;
}

export function snippetViewerRole() {
  return resolveViewer().role;
}

export function isSnippetAdmin() {
  return resolveViewer().role === "admin";
}
